<template>
  <SeoPage page-key="realizzazioneEcommerceLugano" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'RealizzazioneEcommerceLuganoPage'
})
</script>

